/** Frontend mirror domains. API is always at https://api.{domain}. */
export const MIRROR_DOMAINS = [
    'bypass-vpn.ru',
    'wareznet.ru',
    'usebp.ru'
];

export const MIRROR_PROBE_TIMEOUT_MS = 6000;

/**
 * @param {string} domain
 * @returns {{
 *   domain: string,
 *   frontendUrl: string,
 *   apiUrl: string,
 *   statusUrl: string,
 * }}
 */
export function buildMirrorUrls(domain) {
    return {
        domain,
        frontendUrl: `https://${domain}`,
        apiUrl: `https://api.${domain}`,
        statusUrl: `https://api.${domain}/site/status`,
    };
}

/**
 * @param {string} [hostname]
 * @returns {string[]}
 */
export function getMirrorCandidates(hostname = window.location.hostname) {
    return MIRROR_DOMAINS.filter((domain) => domain !== hostname);
}
